import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = { api: vp.Api };
type HookTuple = [
  response: vp.RtrWithdrawResponse,
  RtrWithdraw: (params: vp.RtrWithdrawRequest) => void,
  reset: () => void,
  RtrWithdrawAsync: (params: vp.RtrWithdrawRequest) => Promise<vp.RtrWithdrawResponse>,
];
type ApiHook = (props: HookProps) => HookTuple;

const usePostRtrWithdraw: ApiHook = ({ api }) => {
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [shouldRtrWithdraw, setShouldRtrWithdraw] = useState(false);
  const source = axios.CancelToken.source();
  const [params, setParams] = useState<vp.RtrWithdrawRequest>({
    Amount: 0,
    FirstName: '',
    LastName: '',
    City: '',
    Country: '',
    FinancialInstitutionNumber: '',
    BranchTransitNumber: '',
    AccountNumber: '',
    Token: '',
    Notes: '',
    ClientReferenceNumber: '',
  });
  const [response, setResponse] = useState<vp.RtrWithdrawResponse>({
    Success: false,
    ErrorMessage: '',
    TransactionID: '',
    Flagged: '',
    TransactionStatus: '',
  });

  useEffect(() => {
    if (!shouldRtrWithdraw) return () => {};

    const PostRtrWithdraw = async () => {
      setDataFetchingInfo(true, 'loading some data', 'fullScreen');
      const res = await api.postRtrWithdraw(params, source);
      setResponse(res);
      setDataFetchingInfo(false);
    };

    if (shouldRtrWithdraw) void PostRtrWithdraw();
    setShouldRtrWithdraw(false);
    return () => {
      source.cancel();
    };
  }, [shouldRtrWithdraw]);

  return [
    response,
    (_params: vp.RtrWithdrawRequest) => {
      setParams(_params);
      setShouldRtrWithdraw(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
        TransactionID: '',
        Flagged: '',
        TransactionStatus: '',
      });
      setShouldRtrWithdraw(false);
    },
    async (params: vp.RtrWithdrawRequest) => {
      return api.postRtrWithdraw(params, source);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(usePostRtrWithdraw);
